'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboard = require('./dashboard.html');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboard3 = require('./dashboard.controller');

var _dashboard4 = _interopRequireDefault(_dashboard3);

require('./dashboard.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dashboardComponent = {
  bindings: {},
  template: _dashboard2.default,
  controller: _dashboard4.default,
  controllerAs: "vm"
};

exports.default = dashboardComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.component.js